import { createContext } from 'react';

import { TagGroupProps } from './types';

export type TagGroupContextType = Pick<TagGroupProps<string>, 'isDisabled' | 'isEditable' | 'size' | 'data-testid'>;

export const TagGroupContext = createContext<TagGroupContextType>({
    isDisabled: false,
    isEditable: false,
    size: 'm',
    'data-testid': 'TagGroup',
});
